import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-abm-index',
  templateUrl: './abm-index.component.html',
  styleUrls: ['./abm-index.component.css']
})
export class AbmIndexComponent {

  TipoUsuario = TipoUsuario;

  constructor(public authService: AuthService) { }

}
